export const passwordValidation = {
    message: 'Hasło nie spełnia wymagań bezpieczeństwa',
    validate(password) {
        let status = true;
        // hasAtLeastEightCharacters
        status = status && password.length >= 8;
        // hasAtLeastOneBigLetter
        status = status && !! password.match(/[A-Z]+/);
        // hasAtLeastOneNumber
        status = status && !! password.match(/[0-9]+/);

        return status;
    },
};

export const passwordRepeat = {
    params: ['target'],
    message: 'Podane hasła nie są takie same',
    validate(password, { target }) {
        return password === target;
    },
};
